function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "assistenza");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "path-1",
  points: "6.12244898e-05 -0.00012244898 119.999939 -0.00012244898 119.999939 120 6.12244898e-05 120"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Assets_icone",
  transform: "translate(-840.000000, -2109.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-10",
  transform: "translate(840.000000, 2109.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-3",
  transform: "translate(0.000000, 0.000122)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.9107143,12.2447143 C13.8893265,12.2447143 12.2449592,13.8926327 12.2449592,15.9181837 L12.2449592,84.4896122 C12.2449592,86.5151633 13.8893265,88.1630816 15.9107143,88.1630816 L35.5101429,88.1630816 C38.8915714,88.1630816 41.6325918,90.9042245 41.6325918,94.2855306 L41.6325918,99.096551 L50.7727959,89.9563469 C51.921,88.8082653 53.4783061,88.1630816 55.1019796,88.1630816 L104.089286,88.1630816 C106.110673,88.1630816 107.755041,86.5151633 107.755041,84.4896122 L107.755041,15.9181837 C107.755041,13.8926327 106.110673,12.2447143 104.089286,12.2447143 L15.9107143,12.2447143 Z M35.5089184,120.000061 C34.720102,120.000061 33.9247959,119.84749 33.1673265,119.533653 C30.8793673,118.586143 29.3878163,116.353653 29.3878163,113.877367 L29.3878163,100.40798 L15.9107143,100.40798 C7.13761224,100.40798 6.12244898e-05,93.267 6.12244898e-05,84.4896122 L6.12244898e-05,15.9181837 C6.12244898e-05,7.14079592 7.13761224,-0.000183673469 15.9107143,-0.000183673469 L104.089286,-0.000183673469 C112.862388,-0.000183673469 119.999939,7.14079592 119.999939,15.9181837 L119.999939,84.4896122 C119.999939,93.267 112.862388,100.40798 104.089286,100.40798 L57.6380204,100.40798 L39.839449,118.206551 C38.6682245,119.377776 37.102102,120.000061 35.5089184,120.000061 L35.5089184,120.000061 Z",
  id: "Fill-1",
  fill: "#2D32AA",
  mask: "url(#mask-2)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M60.0612245,65.3484735 C56.6799184,65.3484735 53.9387755,62.6073306 53.9387755,59.2260245 C53.9387755,52.253902 58.5712653,48.4539429 61.9537959,45.6793714 C65.6180816,42.6736163 67.5302449,40.9020245 67.5302449,36.541249 C67.5302449,32.4404327 64.1796735,29.1041878 60.0612245,29.1041878 C55.9427755,29.1041878 52.5922041,32.4404327 52.5922041,36.541249 C52.5922041,39.9225551 49.8510612,42.663698 46.4697551,42.663698 C43.088449,42.663698 40.3473061,39.9225551 40.3473061,36.541249 C40.3473061,25.6884735 49.1909388,16.8592898 60.0612245,16.8592898 C70.9315102,16.8592898 79.7751429,25.6884735 79.7751429,36.541249 C79.7751429,46.8984735 73.7238367,51.8620653 69.7195102,55.1467592 C66.6476327,57.6665143 66.1836735,58.3126776 66.1836735,59.2260245 C66.1836735,62.6073306 63.4425306,65.3484735 60.0612245,65.3484735",
  id: "Fill-4",
  fill: "#2D32AA"
}), /*#__PURE__*/React.createElement("path", {
  d: "M60.6734694,76.0551061 C60.6734694,76.3934327 60.3994286,76.6674735 60.0612245,76.6674735 C59.722898,76.6674735 59.4488571,76.3934327 59.4488571,76.0551061 C59.4488571,75.7170245 59.722898,75.4429837 60.0612245,75.4429837 C60.3994286,75.4429837 60.6734694,75.7170245 60.6734694,76.0551061",
  id: "Fill-6",
  fill: "#2D32AA"
}), /*#__PURE__*/React.createElement("path", {
  d: "M60.0612245,82.7899224 C56.3477143,82.7899224 53.3264082,79.7686163 53.3264082,76.0551061 C53.3264082,72.3415959 56.3477143,69.3205347 60.0612245,69.3205347 C63.7747347,69.3205347 66.7959184,72.3415959 66.7959184,76.0551061 C66.7959184,79.7686163 63.7747347,82.7899224 60.0612245,82.7899224",
  id: "Fill-8",
  fill: "#2D32AA"
}))));

var SvgHelp = function SvgHelp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "120px",
    height: "120px",
    viewBox: "0 0 120 120",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHelp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/help.41e71e81.svg";
export { ForwardRef as ReactComponent };